import { defineMessages } from 'react-intl';
const messages = defineMessages({
    // Panel
    TimeRegistrations: { id: 'TimeRegistrations', defaultMessage: 'Time registrations' },
    // KPI header
    TotalTime: { id: 'TotalTime', defaultMessage: 'Total time' },
    AvgAmountPerHour: { id: 'AvgAmountPerHour', defaultMessage: 'Avg amount per hour' },
    RegisteredAmount: { id: 'RegisteredAmount', defaultMessage: 'Registered amount' },
    BillableAmount: { id: 'BillableAmount', defaultMessage: 'Billable amount' },
    Total: { id: 'Total', defaultMessage: 'Total' },
    // Period buttons
    Yesterday: { id: 'Yesterday', defaultMessage: 'Yesterday' },
    Today: { id: 'Today', defaultMessage: 'Today' },
    PreviousWeek: { id: 'PreviousWeek', defaultMessage: 'Previous week' },
    ThisWeek: { id: 'ThisWeek', defaultMessage: 'This week' },
    PreviousMonth: { id: 'PreviousMonth', defaultMessage: 'Previous month' },
    ThisMonth: { id: 'ThisMonth', defaultMessage: 'This month' },
    PreviousQuarter: { id: 'PreviousQuarter', defaultMessage: 'Previous quarter' },
    ThisQuarter: { id: 'ThisQuarter', defaultMessage: 'This quarter' },
    All: { id: 'All', defaultMessage: 'All' },
    // Filters chrome
    Period: { id: 'Period', defaultMessage: 'Period' },
    ResetFilters: { id: 'ResetFilters', defaultMessage: 'Reset filters' },
    MoreFilters: { id: 'MoreFilters', defaultMessage: 'More filters' },
    SelectAll: { id: 'SelectAll', defaultMessage: 'Select all' },
    // "More filters" dropdown labels
    Companies: { id: 'Companies', defaultMessage: 'Companies' },
    LegalEntities: { id: 'LegalEntities', defaultMessage: 'Legal entities' },
    EndFiscalYear: { id: 'EndFiscalYear', defaultMessage: 'End fiscal year' },
    RelationGroups: { id: 'RelationGroups', defaultMessage: 'Relation groups' },
    HandlingLevels: { id: 'HandlingLevels', defaultMessage: 'Relation handling levels' },
    RelationType: { id: 'RelationType', defaultMessage: 'Relation type' },
    LockedRegistrations: { id: 'LockedRegistrations', defaultMessage: 'Locked registrations' },
    RegistrationsSelected: {
        id: 'RegistrationsSelected',
        defaultMessage: '{selected}/{total} registrations selected',
    },
    // Filter placeholders / labels
    AllUsers: { id: 'AllUsers', defaultMessage: 'All users' },
    SelectResource: { id: 'SelectResource', defaultMessage: 'Select resource' },
    SelectTraining: { id: 'SelectTraining', defaultMessage: 'Select training' },
    RelationsWithLabels: { id: 'RelationsWithLabels', defaultMessage: 'Relations with labels' },
    RelationsWithoutLabels: {
        id: 'RelationsWithoutLabels',
        defaultMessage: 'Relations without labels',
    },
    WithEmployeeLabels: { id: 'WithEmployeeLabels', defaultMessage: 'With employee labels' },
    WithoutEmployeeLabels: {
        id: 'WithoutEmployeeLabels',
        defaultMessage: 'Without employee labels',
    },
    InvoiceDate: { id: 'InvoiceDate', defaultMessage: 'Invoice date' },
    From: { id: 'From', defaultMessage: 'From' },
    Until: { id: 'Until', defaultMessage: 'Until' },
    AssignmentTemplate: { id: 'AssignmentTemplate', defaultMessage: 'Assignment template' },
    ReferenceYear: { id: 'ReferenceYear', defaultMessage: 'Reference year' },
    WithoutReferenceYear: {
        id: 'WithoutReferenceYear',
        defaultMessage: 'Without reference year',
    },
    FilterLockedRegistrationsAll: {
        id: 'FilterLockedRegistrationsAll',
        defaultMessage: 'All',
    },
    FilterLockedRegistrationsUnlocked: {
        id: 'FilterLockedRegistrationsUnlocked',
        defaultMessage: 'Unlocked',
    },
    FilterLockedRegistrationsLocked: {
        id: 'FilterLockedRegistrationsLocked',
        defaultMessage: 'Locked',
    },
    ActiveInactiveRelations: {
        id: 'ActiveInactiveRelations',
        defaultMessage: 'Active - inactive relations',
    },
    // Table columns
    Date: { id: 'Date', defaultMessage: 'Date' },
    User: { id: 'User', defaultMessage: 'User' },
    Relation: { id: 'Relation', defaultMessage: 'Relation' },
    CustomerCode: { id: 'CustomerCode', defaultMessage: 'Customer code' },
    Assignment: { id: 'Assignment', defaultMessage: 'Assignment' },
    Type: { id: 'Type', defaultMessage: 'Type' },
    Resource: { id: 'Resource', defaultMessage: 'Resource' },
    Task: { id: 'Task', defaultMessage: 'Task' },
    Training: { id: 'Training', defaultMessage: 'Training' },
    To: { id: 'To', defaultMessage: 'To' },
    Quantity: { id: 'Quantity', defaultMessage: 'Quantity' },
    UnitPrice: { id: 'UnitPrice', defaultMessage: 'Unit price' },
    VatPercent: { id: 'VatPercent', defaultMessage: '% VAT' },
    Amount: { id: 'Amount', defaultMessage: 'Amount' },
    IsFixedPrice: { id: 'IsFixedPrice', defaultMessage: 'Fixed price' },
    Billable: { id: 'Billable', defaultMessage: 'Billable' },
    InForfait: { id: 'InForfait', defaultMessage: 'In forfait' },
    InvoiceInForfait: { id: 'InvoiceInForfait', defaultMessage: 'Invoice in forfait' },
    NeverInvoice: { id: 'NeverInvoice', defaultMessage: 'Never invoice' },
    Invoice: { id: 'Invoice', defaultMessage: 'Invoice' },
    Remark: { id: 'Remark', defaultMessage: 'Remark' },
    Actions: { id: 'Actions', defaultMessage: 'Actions' },
    NoForfaitSchedule: {
        id: 'NoForfaitSchedule',
        defaultMessage: 'This relation does not have a forfait invoice schedule.',
    },
    SystemUser: { id: 'SystemUser', defaultMessage: 'System user' },
    NoResults: { id: 'msgPagingNoResults', defaultMessage: 'No results found' },
    // Add menu
    Add: { id: 'Add', defaultMessage: 'Add' },
    AddRegistration: { id: 'AddRegistration', defaultMessage: 'Add registration' },
    AddAbsence: { id: 'AddAbsence', defaultMessage: 'Add absence' },
    AddRecuperation: { id: 'AddRecuperation', defaultMessage: 'Add recuperation' },
    AddTraining: { id: 'AddTraining', defaultMessage: 'Add training' },
    AddRegistrationFor: { id: 'AddRegistrationFor', defaultMessage: 'Add registration for {user}' },
    AddAbsenceFor: { id: 'AddAbsenceFor', defaultMessage: 'Add absence for {user}' },
    AddRecuperationFor: { id: 'AddRecuperationFor', defaultMessage: 'Add recuperation for {user}' },
    AddTrainingFor: { id: 'AddTrainingFor', defaultMessage: 'Add training for {user}' },
    // Row actions
    EditRegistration: { id: 'EditRegistration', defaultMessage: 'Edit registration' },
    ViewRegistration: { id: 'ViewRegistration', defaultMessage: 'View registration' },
    DeleteRegistration: { id: 'DeleteRegistration', defaultMessage: 'Delete registration' },
    OpenDraftInvoice: { id: 'OpenDraftInvoice', defaultMessage: 'Open draft invoice' },
    OpenInvoice: { id: 'OpenInvoice', defaultMessage: 'Open invoice' },
    OpenTaskDetails: { id: 'OpenTaskDetails', defaultMessage: 'Open task details' },
    AddRegistrationToDraftInvoice: {
        id: 'AddRegistrationToDraftInvoice',
        defaultMessage: 'Add registration to draft invoice',
    },
    RevertToRegistrations: { id: 'RevertToRegistrations', defaultMessage: 'Revert to registrations' },
    InvoicedCannotBeRemoved: {
        id: 'InvoicedCannotBeRemoved',
        defaultMessage: 'An invoiced registration cannot be removed from the invoice',
    },
    InvoicedCannotBeDeleted: {
        id: 'InvoicedCannotBeDeleted',
        defaultMessage: 'An invoiced registration cannot be deleted',
    },
    LockRegistration: { id: 'LockRegistration', defaultMessage: 'Lock registration for editing.' },
    UnlockRegistration: {
        id: 'UnlockRegistration',
        defaultMessage: 'Unlock registration for editing',
    },
    // Confirmations & toasts
    ConfirmDeleteTitle: { id: 'msgConfirmDeleteTitle', defaultMessage: 'Delete?' },
    ConfirmDeleteRegistration: {
        id: 'msgConfirmDeleteRegistration',
        defaultMessage: 'Are you sure you want to delete this registration?',
    },
    ConfirmUndoOrNeverInvoiceDetailLine: {
        id: 'comfirmUndoOrNeverInvoiceDetailLine',
        defaultMessage: 'Do you want to remove this registration from the invoice and never invoice it again, or move it to the next billing period?',
    },
    AddedRegistrationToDraft: {
        id: 'msgAddedRegistrationToDraftInvoice',
        defaultMessage: 'Registration added to draft invoice',
    },
    RemovedRegistrationFromDraft: {
        id: 'msgRemovedRegistrationFromDraftInvoice',
        defaultMessage: 'Registration removed from draft invoice',
    },
    NoInvoiceCreated: {
        id: 'msgInvoiceRegistrationNoInvoiceCreated',
        defaultMessage: 'No invoice was created for this registration',
    },
    RegistrationIsLockedForDelete: {
        id: 'msgRegistrationIsLockedForDelete',
        defaultMessage: 'This registration is locked and cannot be deleted',
    },
    // Delete-with-never-invoice confirm
    NeverInvoiceAgain: {
        id: 'NeverInvoiceAgain',
        defaultMessage: 'Never invoice registration(s) again',
    },
    InvoiceNextBillingPeriod: {
        id: 'InvoiceNextBillingPeriod',
        defaultMessage: 'Invoice next billing period',
    },
    Cancel: { id: 'Cancel', defaultMessage: 'Cancel' },
    // Toolbar: column config / export / global actions
    ColumnConfig: { id: 'ColumnConfig', defaultMessage: 'Columns' },
    SelectTableColumns: { id: 'msgSelectTableColumns', defaultMessage: 'Select columns' },
    Export: { id: 'Export', defaultMessage: 'Export' },
    ExportRegistrationsToExcel: {
        id: 'ExportRegistrationsToExcel',
        defaultMessage: 'Export registrations to Excel',
    },
    GlobalActions: { id: 'GlobalActions', defaultMessage: 'Global actions' },
    ModifyRegistration: { id: 'ModifyRegistration', defaultMessage: 'Modify registration' },
    DeleteRegistrations: { id: 'DeleteRegistrations', defaultMessage: 'Delete registrations' },
    BatchLockRegistrations: {
        id: 'BatchLockRegistrations',
        defaultMessage: 'Lock registrations',
    },
    BatchUnlockRegistrations: {
        id: 'BatchUnlockRegistrations',
        defaultMessage: 'Unlock registrations',
    },
    AddToInvoiceProposal: {
        id: 'AddToInvoiceProposal',
        defaultMessage: 'Add to invoice proposal',
    },
    RevertToRegistrationsAction: {
        id: 'RevertToRegistrationsAction',
        defaultMessage: 'Revert to registrations',
    },
    ExportToExcelStarted: { id: 'ExportToExcelStarted', defaultMessage: 'Export to Excel started' },
    JobStarted: {
        id: 'msgJobStarted',
        defaultMessage: 'Job started, click here to follow its progress',
    },
    // Batch confirmations
    ConfirmTitle: { id: 'comfirmTitle', defaultMessage: 'Confirm' },
    ConfirmDeleteRegistrations: {
        id: 'msgConfirmDeleteRegistrations',
        defaultMessage: 'Are you sure you want to delete {count} registration(s)?',
    },
    ConfirmLockRegistrations: {
        id: 'msgConfirmLockRegistrations',
        defaultMessage: 'Lock {count} registration(s)?',
    },
    ConfirmUnlockRegistrations: {
        id: 'msgConfirmUnlockRegistrations',
        defaultMessage: 'Unlock {count} registration(s)?',
    },
    ConfirmBillRegistrations: {
        id: 'msgConfirmBillRegistrations',
        defaultMessage: 'Add the selected registrations to an invoice proposal?',
    },
    ConfirmUndoOrNeverInvoiceRegistrations: {
        id: 'comfirmUndoOrNeverInvoiceRegistrations',
        defaultMessage: 'Do you want to remove the selected registrations from their invoices and never invoice them again, or move them to the next billing period?',
    },
    // Column-filter labels
    Yes: { id: 'Yes', defaultMessage: 'Yes' },
    No: { id: 'No', defaultMessage: 'No' },
    NotApplicable: { id: 'NotApplicable', defaultMessage: 'Not applicable' },
    // Batch update field modal
    UpdateField: { id: 'UpdateField', defaultMessage: 'Update field' },
    Field: { id: 'Field', defaultMessage: 'Field' },
    ChooseField: { id: 'ChooseField', defaultMessage: 'Choose a field' },
    Which: { id: 'Which', defaultMessage: 'Which' },
    SelectAssignment: { id: 'SelectAssignment', defaultMessage: 'Select an assignment' },
    SelectReferenceYear: { id: 'SelectReferenceYear', defaultMessage: 'Select reference year' },
    Save: { id: 'Save', defaultMessage: 'Save' },
    BatchUpdateInfo: {
        id: 'BatchUpdateInfo',
        defaultMessage: 'The global action will only be applied to registrations that are not locked and not yet billed. Locked registrations or registrations on draft and numbered invoices will be skipped.',
    },
    BatchUpdateSuccess: {
        id: 'msgBatchUpdateRegistrationsSuccess',
        defaultMessage: '{count} registration(s) updated',
    },
    RegistrationsWillBeModifiedInBackground: {
        id: 'msgRegistrationsWillBeModifiedInTheBackground',
        defaultMessage: 'The registrations will be modified in the background',
    },
    CannotSelectRelationWithoutInvoiceStreams: {
        id: 'msgCannotSelectRelationWithoutInvoiceStreams',
        defaultMessage: 'This relation has no invoice streams and cannot be selected',
    },
    // Invoice detail report modal
    ExportRegistrationsWithDetailTemplate: {
        id: 'ExportRegistrationsWithDetailTemplate',
        defaultMessage: 'Export registrations with detail template',
    },
    Template: { id: 'Template', defaultMessage: 'Template' },
    Choose: { id: 'Choose', defaultMessage: 'Choose' },
    GenerateAsWord: { id: 'GenerateAsWord', defaultMessage: 'Generate as Word' },
    GenerateAsPdf: { id: 'GenerateAsPdf', defaultMessage: 'Generate as PDF' },
    PleaseFilterOnRelation: {
        id: 'PleaseFilterOnRelation',
        defaultMessage: 'Please filter on a relation first',
    },
});
export default messages;
